import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import StatusSensorsTable from "components/tables/status-sensors/StatusSensorsTable.component";
import MainCard from "components/common/card/MainCard";
import { ListPagination } from "components/tables/list";
import ErrorCardcomponent from "components/common/card/ErrorCard.component";
import { Loading } from "components/common";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveSearch } from "store/user.store";

const SUPERUSER = "superuser";
const OPERATOR = "operator";

const WarningSensorsContainer = ({
  values,
  onClick = () => {},
  isLoading = true,
  userRole,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [slice, setSlice] = useState(25);
  const [count, setCount] = useState(0);
  const [dataFilter, setDataFilter] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("stationId");

  const TABLE_HEAD_VISITOR = useMemo(
    () => [
      { id: "stationId", label: "ID", alignRight: false, order: true },
      { id: "address", label: t("Address"), alignRight: false, order: true },
      { id: "cluster", label: "Cluster", alignRight: false, order: true },
      {
        id: "componentStatus",
        label: t("Component status"),
        alignRight: false,
        order: true,
      },
      { id: "status", label: t("Status"), alignRight: false, order: true },
    ],
    [t]
  );

  const TABLE_HEAD = useMemo(
    () => [
      { id: "info", label: "", alignRight: false, order: false },
      { id: "stationId", label: "ID", alignRight: false, order: true },
      { id: "address", label: t("Address"), alignRight: false, order: true },
      { id: "cluster", label: "Cluster", alignRight: false, order: true },
      {
        id: "componentStatus",
        label: t("Component status"),
        alignRight: false,
        order: false,
      },
      { id: "status", label: t("Status"), alignRight: false, order: false },
      { id: "viewStation", label: "", alignRight: false, order: false },
    ],
    [t]
  );
  const onClickStation = useCallback((item) => {
    dispatch(saveSearch(item));
    navigate("/dashboard/management/monitoring-points-list");
    // eslint-disable-next-line
  }, []);

  const onRequestSort = useCallback(
    (event, property) => {
      const isAsc = order === "asc" ? "desc" : "asc";
      setOrder(isAsc);
      setOrderBy(property);
    },
    [order]
  );

  const onPageChange = useCallback((event, newPage) => {
    setPage(newPage);
    // eslint-disable-next-line
  }, []);

  const onRowsPerPageChange = useCallback((event) => {
    setSlice(parseInt(event.target.value));
    setPage(0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (values) {
      if (!_.isEmpty(values)) {
        setCount(values.length);
      }
      setDataFilter(values);
    }
  }, [values]);

  return (
    <Fragment>
      <MainCard
        title={t("Attention status monitoring points list")}
        content={false}
      >
        {isLoading ? (
          <Box m={3}>
            <Loading />
          </Box>
        ) : values && !_.isEmpty(values) ? (
          <Fragment>
            <StatusSensorsTable
              header={
                userRole === SUPERUSER || userRole === OPERATOR
                  ? TABLE_HEAD
                  : TABLE_HEAD_VISITOR
              }
              data={dataFilter}
              page={page}
              rowsPerPage={slice}
              onClick={onClick}
              status="Attenzione"
              onRequestSort={onRequestSort}
              order={order}
              orderBy={orderBy}
              onClickStation={onClickStation}
              userRole={userRole}
            />

            <ListPagination
              rowsPerPageOptions={[10, 25, 50, 100, 250]}
              component="div"
              count={count}
              rowsPerPage={slice}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
            />
          </Fragment>
        ) : (
          <Box m={2}>
            <ErrorCardcomponent
              sx={{ border: "none" }}
              message={t("No monitoring points in alert state")}
            />
          </Box>
        )}
      </MainCard>
    </Fragment>
  );
};

export default WarningSensorsContainer;
